import { Component, OnInit, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import {  AuthService } from '../auth.service';
import {  CommonService } from '../../services/common.service';
import { Response, Request} from '@angular/http';
import { Router } from '@angular/router';
import {Users } from '../../classes/users';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';

import { MatSnackBar } from '@angular/material';
import {Observable} from 'rxjs';
import { CartService } from '../../services/cart.service';
import { DoctorService } from '../../services/doctor.service';
import {  Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
})
export class SigninComponent implements OnInit {
  temparray = [];
  temcartdatalength: any;
  loading = false;
    error = '';
    loginform: any;
    redirecrcheckflag: number;
    userStatus: number;
    timer: any;
    ctimer = 5;
    msg: any;
    action: any;
    tempuserid: any;
    tempcartdata: any;
    currentusercartdata: any;
  constructor( private router: Router, private authService: AuthService, public form: FormBuilder,
  public commonservice: CommonService, private doctorservice: DoctorService,  public snackBar: MatSnackBar,
private zone: NgZone, private cartService:CartService,@Inject(PLATFORM_ID) private platformId: Object) {
  this.tempuserid = this.authService.checkUserTempData();
  console.log(this.tempuserid);
    this.loginform = this.form.group({
      'email': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required]),
     });
     this.redirecrcheckflag = this.commonservice.getActivatepath();
     this.gettemproraryuserCartItem();
   }

  ngOnInit() {
    const temp = this.commonservice.getUserDataLocally();
    this.userStatus = this.commonservice.checkUserStatus();
    console.log(temp, this.userStatus);
    if (this.userStatus === 1) {
     this.timer = setInterval(() => this.redirectAutomaticToDashboard(), 1000);
    }
  }
  gettemproraryuserCartItem() {
    this.cartService.getUserCartItems(this.tempuserid)
    .subscribe((x)=>{
      this.tempcartdata = x;
    })
  }
  redirectAutomaticToDashboard() {
    this.ctimer = this.ctimer - 1 ;
    if (this.ctimer === 0) {
      clearInterval(this.timer);
      this.router.navigate([''])
    }
}
     onSignin(form: NgForm) {
       this.loading = true;
        this.authService.Signin( this.loginform.email, this.loginform.password)
            .subscribe(result => {
                        if (result === true) {
                          if (isPlatformBrowser(this.platformId)) {
                          localStorage.removeItem('activatepath');
                          }
                          this.authService.setRoleId(2);
                          this.checkingTemporarycart();
                        }
                  }, (err) => {
            this.loading = false;
            this.msg = 'Username or password is incorrect';
            this.openSnackBar();
        });
}
openSnackBar() {
  this.snackBar.open(this.msg , this.action, {
  duration: 4000,
  });
}
checkingTemporarycart() {
  if (this.tempcartdata.length == 0) {
    this.loading = false;
    this.movetoSpecificPath();
  } else {

   /* this.authService.tempuid(this.tempuserid)
    .subscribe(
        (x) => {
        console.log(x);
    }); */
    var check= this.isANumber(this.loginform.email);
    if (check === false ){
    console.log('in if');
      this.cartService.getUserData(this.loginform.email)
      .subscribe(
          (x) => {
          const uid = x[0].id;
          this.getCurrentuserCartItem(uid);
        }); 
    } else {
      console.log('in else');
      this.cartService.getUserDataByMobile(this.loginform.email)
      .subscribe(
          (x) => {
          const uid = x[0].id;
          this.getCurrentuserCartItem(uid);
        }); 
    }

 
     }
}
getCurrentuserCartItem(uid) {
  this.cartService.getUserCartItems(uid)
  .subscribe((x)=>{
    this.currentusercartdata = x;
    if (this.currentusercartdata.length == 0) {
      this.updateUserIdIntoCartDb(uid);
     } else {
       this.updateCartQuantityIntodb(uid);
     }
  })
}
updateUserIdIntoCartDb(uid) {
  let tempcartlength = this.tempcartdata.length
  for (let i=0 ; i < this.tempcartdata.length ;i++) {
    this.cartService.updateUseridInCart(this.tempcartdata[i].id, uid)
    .subscribe(
      (x) => {
        tempcartlength = tempcartlength - 1;
        if(tempcartlength == 0) {
          this.loading = false;
          console.log('move to specific path from updateUserIdIntoCartDb');
          this.movetoSpecificPath();
        }
      });
  }
}
updateCartQuantityIntodb(uid) {
  this.temcartdatalength = this.tempcartdata.length;
  this.temparray =[];
  for(let i = 0 ;i <this.tempcartdata.length; i++) {
    let temindex = this.tempcartdata[i].id;
    let sku = this.tempcartdata[i].sku;
    let flag  = 0;
    let index = this.tempcartdata[i].id;
    let quantity = this.tempcartdata[i].quantity;
    let payabl =  this.tempcartdata[i].payable;
   for (let i = 0; i < this.currentusercartdata.length; i++) {
         if (this.currentusercartdata[i].sku === sku) {
           flag = flag +1;
           quantity = quantity + this.currentusercartdata[i].quantity;
           payabl = payabl + this.currentusercartdata[i].payable;
           index = this.currentusercartdata[i].id;
         }
       }
       if (flag > 0) {
         this.temparray.push(temindex);
        this.UpdateCartDeatail(index, quantity,  payabl)
       }else {
         this.updateOnlyuserId(uid,index);
       }
    }
   }
   updateOnlyuserId(uid, index){
    this.cartService.updateUseridInCart(index, uid)
    .subscribe(
      (x) => {
        this.temcartdatalength = this.temcartdatalength - 1;
        if (this.temcartdatalength == 0) {
          console.log('updateOnlyuserId');
         // this.deleteTempraryusercart();
         this.movetoSpecificPath();
        }
      });
   }
   UpdateCartDeatail(index, quantity,  paybl) {
     this.cartService.updateUserQuantityIncart(index,quantity , paybl)
       .subscribe(
        (x) => {
          this.temcartdatalength = this.temcartdatalength - 1;
          if (this.temcartdatalength == 0) {
            this.deleteTempraryusercart();
          }
        });
   }
   deleteTempraryusercart() {
    let temparraylength = this.temparray.length;
    for(let i = 0 ;i <this.temparray.length; i++) {
     this.cartService.deleteCart(this.temparray[i])
     .subscribe(
       (x) =>{
        temparraylength = temparraylength - 1;
        if (temparraylength == 0) {
          this.loading = false;
          this.temparray = [];
          console.log('delete cart');
          console.log('move to specific path from deletetempraryusercart');
          this.movetoSpecificPath();
        }
       });
      }
   }
movetoSpecificPath() {
  if (isPlatformBrowser(this.platformId)) {
  localStorage.removeItem('idata');
  this.commonservice.loginsuccess.next(1);
  if (this.redirecrcheckflag === 0) {
    this.router.navigate(['']);
  } else if (this.redirecrcheckflag === 2) {
    this.router.navigate(['/store/checkout']);
  } else if (this.redirecrcheckflag === 3) {
    this.router.navigate(['/pulse/onlinedoctors']);
  }else if (this.redirecrcheckflag === 4) {
    this.router.navigate(['/petadoption/formfillup']);
  }else if (this.redirecrcheckflag === 5) {
    const temp = localStorage.getItem('adopreq');
    localStorage.removeItem('adopreq');
    this.router.navigate(['/petadoption/adoptionrequest/' + temp]);
  }else if (this.redirecrcheckflag === 6) {
    this.router.navigate(['/forum/asktovet']);
  }else if (this.redirecrcheckflag === 7) {
    this.router.navigate(['/pulse/doctor']);
  } else if (this.redirecrcheckflag === 8) {
    this.router.navigate(['/pulse/setreminder']);
  } else if (this.redirecrcheckflag === 9) {
    this.router.navigate(['/nest/booking']);
  } else {
    this.router.navigate(['']);
  }
}
}

isANumber(str) {
  return !/\D/.test(str);
}
}
